export const WORD_LIST_COLLECTION = [
	{
		title: "LinkModuleWordsWith",
		link: "LinkModuleWordsWithLink",
		allLinksEn: 32,
		allLinksEs: 49,
		limitLinks: 5,
	},
	{
		title: "LinkModuleWordsStart",
		link: "LinkModuleWordsStartLink",
		allLinksEn: 26,
		allLinksEs: 51,
		limitLinks: 5,
	},
	{
		title: "LinkModuleWordsEnd",
		link: "LinkModuleWordsEndLink",
		allLinksEn: 26,
		allLinksEs: 51,
		limitLinks: 5,
	},
	{
		title: "LinkModuleWordsNumber",
		link: "LinkModuleWordsNumberLink",
		allLinksEn: 31,
		allLinksEs: 22,
		limitLinks: 5,
	},
	{
		title: "LinkModuleOtherLists",
		link: "",
		allLinksEn: 4,
		limitLinks: 4,
	},
];

export const PAGE_GROUPS = {
	LETTERS_PAGE: "lettersPage",
	LENGTH_PAGE: "lengthPage",
	SPECIALS_PAGE: "specialsPage",
	UNSCRAMBLE_PAGE: "unscramblePage",
	SCRABBLE_PAGE: "scrabblePage",
};

/**
 * All page names. Any reference to a page within the app SHOULD always be
 * expressed as `PAGES.WHATEVER`, so please don't use the strings anywhere.
 * It makes the codebase more consistent an readable.
 */
export const PAGES = {
	ANAGRAM: "homeAnagram",
	APP_ABOUT: "aboutApp",
	APP_PRIVACY_POLICY: "privacyPolicy",
	FOURPICS: "home4Pics1Word",
	FOURPICS_RESULTS: "results4Pics1Word",
	HOME: "Home",
	JUMBLE_SOLVER: "homeJumbleSolver",
	TEXT_TWIST: "homeTextTwist",
	WORD_SWIPE_CHEATS: "homeWordSwipeCheats",
	DYNAMIC_PAGE: "dynamicPage",
	DYNAMIC_RESULTS_PAGE: "dynamicResultsPage",
	NOT_FOUND: "pageNotFound",
	SCRABBLE_DICT: "homeWordGame",
	SCRABBLE_DICT_RESULTS: "resultsWordgGame",
	SCRABBLE_EXACTMATCH_RESULTS: "resultsExactWordGame",
	UNSCRAMBLE: "homeUnscramble",
	UNSCRAMBLER_RESULTS: "resultsUnscramble",
	UNSCRAMBLER_RESULTS_REMEMBER: "resultsUnscrambleTiles",
	WORDCOOKIES: "homeWordCookies",
	WORDFEUD: "homeWordFeud",
	WORDBRAIN_ANSWERS: "homeWordbrainAnswers",
	WORDS_BY_LENGTH_INDEX: "homeWordsByLength",
	WORDS_BY_LENGTH_RESULTS: "resultsWordsByLength",
	WORDS_CONSONANTS: "resultsWordsConsonants",
	WORDS_ENDING_INDEX: "homeWordsEndingWith",
	WORDS_ENDING_ING: "resultsWordsEndingING",
	WORDS_ENDING_RESULTS: "resultsWordsEndingWith",
	WORDS_HAVING_INDEX: "homeWordsWith",
	WORDS_HAVING_RESULTS: "resultsWordsWith",
	WORDS_LISTS_INDEX: "homeWordListsIndex",
	WORDS_STARTING_INDEX: "homeWordsStartingWith",
	WORDS_STARTING_RESULTS: "resultsWordsStartingWith",
	WORDS_VOWELS: "resultsWordsVowels",
	WORDS_WITH_Q_NO_U: "resultsWordsQNoU",
	WORD_MAKER: "homeWordMaker",
	SCRABBLE_CHECKER: "homeScrabbleChecker",
	WORD_DESCRAMBLER: "homeWordDescrambler",
	WORD_CHUMS_CHEAT: "homeWordChumsCheat",
	LETTERS_AND_BLANK: "homeLettersAndBlank",
	ARTICLE_INDEX: "articleIndex",
	ARTICLE_DETAIL: "articleDetail",
	WWF: "homeWordsWithFriends",
	WORDSCAPES: "homeWordscapes",
	WORD_CONNECT: "homeWordConnect",
	GAME_CHEATS: "resultsGameCheats",
	WORD_STORY: "homeWordStory",
	CODY_CROSS: "homeCodyCross",
	SAVED_WORDS: "savedWords",
	WORD_SCRAMBLE: "homeWordScramble",
	GET_THE_APP: "getTheApp",
};
